import * as React from "react";
import { useSelector } from "react-redux";
import { Label } from "semantic-ui-react";

import { getEmployeeRecordDocumentCount } from "../../actions";
import { employeeRecord as employeeRecordSelector } from "../../selectors";

export const DocumentsTabLabel = () => {
    const employeeRecord = useSelector(employeeRecordSelector);
    const [documentCount, setDocumentCount] = React.useState<number>(0);

    React.useEffect(() => {
        const getDocumentCount = async () => {
            if (employeeRecord) {
                const result = await getEmployeeRecordDocumentCount(employeeRecord.customerId, employeeRecord.id);
                setDocumentCount(result);
            }
        };
        getDocumentCount();
    }, [employeeRecord, employeeRecord?.customerId, employeeRecord?.id, setDocumentCount]);

    if (!documentCount || documentCount === 0) {
        return null;
    }

    return (
        <Label circular color="red" floating className="document-label">{documentCount}</Label>
    );
};
